import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Brief post-login splash — shows the brand, then moves the operator
// to /order after a second. Navigating with replace so the back button
// doesn't land them back here.
export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/order', { replace: true }), 1000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="hc-home-splash">
      <h1 className="hc-home-splash__heading">HalloChef</h1>
      <img
        src="/hallochef.svg"
        alt="HalloChef"
        className="hc-home-splash__logo"
      />
    </div>
  );
}
